import throttle from 'lodash/throttle';

export default class Animation {
  constructor() {
    this.block = document.querySelectorAll('.anim-block');
    this.animTargets = '.fade-up, .fade-in, .anim-hero, .slide-reveal';
    this.animate = this.animate.bind(this);

    this.init();
  }

  init() {
    if (!this.block) return;
    this.animate();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.animate, 100));
  }

  animate() {
    const x = 1.3;

    this.block.forEach(bl => {
      let isInView = bl.getBoundingClientRect().top <= window.innerHeight / x;

      if (isInView) {
          let elements = bl.querySelectorAll(this.animTargets);

          elements.forEach(el => {
            const delay = parseInt(el.getAttribute('data-delay'), 10) || 0;
            setTimeout(() => el.classList.add('is-over'), delay);
          });
      }
    });
  }
}
